import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/fromPromise';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  url: string = 'https://admin.centrebenevoleabc.org';
  //url: string = 'http://localhost/cabc/public/index.php';
  oauth: object = {
    grant_type: 'password',
    client_id: '1_3bcbxd9e24g0gk5plj0kwgcwg4o8k8g4g123kwc44gcc0gwwk4',
    client_secret: '4ok2x70rlhlnj8g0wws8c8kwcokw80l56lg48goc0ok4w0so0k'
  };

  constructor(public http: HttpClient, private storage: Storage) {
  }

  get(endpoint: string, params?: any, reqOpts?: any,) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    return Observable.fromPromise(this.storage.get('token')).mergeMap( token => {
      if( token) {
        reqOpts.headers = {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + token
        }
      }
      
      // make request 
      return this.http.get(this.url + '/' + endpoint, reqOpts);
    });
    //return this.http.get(this.url + '/' + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any) {

    return Observable.fromPromise(this.storage.get('token')).mergeMap( token => {
      if (endpoint == 'oauth/v2/token' || endpoint == 'updatepassword' || endpoint == 'forgottenpassword' || endpoint == 'subscribe') {
        token = null;
      }
      if( token) {
        if (endpoint != 'checktoken') {
          if (!reqOpts) {
            reqOpts = {
              params: new HttpParams()
            };
          }
          reqOpts.headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token
          }
        } else {
          return this.http.post(this.url + '/' + endpoint,  {'token' : token}, reqOpts);
        }

      }
      
      // make request 
      return this.http.post(this.url + '/' + endpoint, Object.assign(body, this.oauth), reqOpts);
    });
    
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    return this.http.delete(this.url + '/' + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.patch(this.url + '/' + endpoint, body, reqOpts);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts